<script>

    import VcModal from "@/components/Form/Modal"
    import BaixaParcela from "./services/baixa_parcela"
    import bus from "../../bus";
    import VcModalObsInterna from "./ModalObsInterna.vue";

    export default {
        props: ['analiseProp', 'navigate'],
        components: {
            VcModal,
            VcModalObsInterna
        },
        data() {
            return {
                isOpen: true,
                analise: {}
            }
        },
        watch: {
            analiseProp: {
                immediate: true,
                handler(novaAnalise) {
                    this.analise = novaAnalise;
                    this.isOpen = true;
                }
            }
        },
        computed: {
            gerente() {
                return parseInt(this.$store.state.Auth.user.permissao_empresa.gerente) || parseInt(this.$store.state.Auth.user.permissao_empresa.master)
            }
        },
        methods: {
            baixaPDFAdubacao(analise){
                this.$http.post('/api/analises/downloadAdubacao', {id: analise}).then(response => {
                    if (response) {
                        const pdfWindow = window.open("");
                        pdfWindow.document.write(
                            "<iframe width='100%' height='100%' style='border:none' src='data:application/pdf;base64," +
                            response.data.base64 +
                            "'></iframe>"
                        );
                    } else {
                        window.swal("Atenção", "Não foi possível gerar o PDF.", "warning");
                    }
                })
            },

            downloadBoletoAnalise(analise) {
                this.$http.get("api/analises/get-boleto/" + analise.id, {'enviaEmail': false}).then(response => {
                    if (response.data.pdf == null) {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao imprimir boleto.<br><br>" +
                            response.data.mensagem,
                            "warning"
                        );
                    }
                    let a = document.createElement("a");
                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                    a.download = "Boleto_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                    a.click();
                });
            },

            closeModal() {
                this.isOpen = false;
                this.analise = {};
                this.$emit('close');
            },

            alterar(analise) {
                this.$router.push({name: "analises.editar", params: {id: analise.id}});
            },

            remover(analise) {
                const self = this
                window.swal({
                    title: 'Informe a senha.',
                    input: 'password',
                    showCancelButton: true,
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: 'Cancelar',
                    showLoaderOnConfirm: true,
                    preConfirm: (senha) => {
                        if (senha == self.$store.state.Empresa.configuracao.senha) {
                            setTimeout(function () {
                                self.deletarAnalise(analise)
                            }, 200)
                        } else {
                            window.swal.showValidationMessage('Senha inválida.')
                            return false
                        }
                    }
                })
            },

            deletarAnalise(analise) {
                window.swal({
                    title: "Remover registro?",
                    text: "Deseja realmente remover a análise selecionada?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                }).then(result => {
                    if (result.value) {
                        this.$http.delete("api/analises/" + analise.id).then(() => {
                            bus.$emit('atualizarListagemAnalises');
                            return window.swal("Sucesso", "Análise removida com sucesso.", "success");
                        }).catch(error => {
                            return window.swal("Atenção", "Houve um problema ao remover a análise. <br><br>" + error.response.data.message, "warning");
                        });
                    }
                });
            },

            digitarResultado(analise) {
                this.$store.dispatch("setModel", analise);
                this.$router.push({name: "analises.resultado"});
            },

            downloadProtocolo(analise) {
                this.$http.get("api/analises/get-protocolo/" + analise.id).then(response => {
                    if (response.data.pdf == null) {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao gerar o protocolo.<br><br>" +
                            response.data.mensagem,
                            "warning"
                        );
                    }
                    let a = document.createElement("a");
                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                    a.download = "Protocolo_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                    a.click();
                });
            },

            downloadNfse(analise) {
                this.$http.get("api/analises/get-nfse/" + analise.id).then(response => {
                    if (response.data.pdf == null) {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao baixar NFS-e.<br><br>" +
                            response.data.mensagem,
                            "warning"
                        );
                    }
                    let a = document.createElement("a");
                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                    a.download = "NFSe_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                    a.click();
                });
            },

            downloadResultado(analise) {
                this.$http
                    .get("api/analises/get-resultado/" + analise.id)
                    .then(response => {
                        if (response.data.pdf == null) {
                            return window.swal(
                                "Atenção",
                                "Houve um problema ao gerar o resultado.<br><br>" +
                                response.data.mensagem,
                                "warning"
                            );
                        }
                        let a = document.createElement("a");
                        a.href = "data:application/octet-stream;base64," + response.data.pdf;
                        a.download = "Resultado_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                        a.click();
                    });
            },

            downloadResultadoExcel(analise) {
                this.$http
                    .get("api/analises/get-resultado-excel/" + analise.id)
                    .then(response => {
                        if (response.data.excel == null) {
                            return window.swal(
                                "Atenção",
                                "Houve um problema ao gerar o resultado.<br><br>" +
                                response.data.mensagem,
                                "warning"
                            );
                        }

                        let a = document.createElement("a");
                        a.href = response.data.excel;
                        a.download = "Resultado_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".xlsx";
                        a.click();
                    });
            },

            buscaParcela(analise) {
                this.$http.post("api/parcela/buscaParcelaAnalise/" + analise.id).then(async response => {
                    let parcela = response.data.parcela

                    window.swal("Atenção", "Parcela com vencimento no dia " + parcela[0].data_formatada + (response.data.boleto.length > 0 ? "<br><br> Boleto de nosso número " + response.data.boleto[0].nosso_numero_boleto + " vínculado a esta parcela." : ""), "warning").then(() => {
                        window.swal({
                            title: "Baixar parcela",
                            text: "Deseja realizar a baixa desta parcela?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não"
                        }).then(async result => {
                            if (result.value) {
                                await BaixaParcela.baixar(parcela, analise, response.data.analisesPedido);    //baixa
                                window.swal("Sucesso!", "Parcela baixada com sucesso.", "success")
                            }
                        });
                    });
                });
            }
        },
        mounted() {
            this.$set(this, 'analise', this.analiseProp)
        }
    }
</script>

<template>
    <vc-modal v-if="isOpen" @close="closeModal">
        <div slot="header">Ações</div>
        <div slot="body">
            <button
                    class="btn btn-info btn-block"
                    @click="downloadProtocolo(analise); closeModal()"
                    title="Protocolo">
                <i class="fa fa-print"></i> Protocolo
            </button>
            <button v-if="analise.emitir_nota && analise.pedido_id != null"
                    class="btn btn-info btn-block"
                    @click="downloadNfse(analise); closeModal()"
                    title="NFS-e">
                <i class="fa fa-print"></i> NFS-e ({{ analise.numeroNota }})
            </button>
            <button v-if="analise.data_resultado != null && analise.data_resultado.length > 0"
                    class="btn btn-info btn-block"
                    @click="downloadResultado(analise); closeModal()"
                    title="Resultado">
                <i class="fa fa-print"></i> Resultado
            </button>
            <button v-if="analise.tipo == 'SOLO' && analise.data_resultado != null && analise.data_resultado.length > 0"
                    class="btn btn-info btn-block"
                    style="background-color: gray; color: white;"
                    @click="downloadResultadoExcel(analise); closeModal()"
                    title="Resultado">
                <i class="fa fa-file-excel"></i> Resultado Excel
            </button>
            <vc-modal-obs-interna :analise-prop="analise" @close="closeModal()" ></vc-modal-obs-interna>
            <button v-if="analise.forma_pagamento === 'BOLETO' && analise.faturado == '0' && analise.pedido_id != null"
                    class="btn btn-info btn-block"
                    @click="downloadBoletoAnalise(analise); closeModal()"
                    title="Protocolo">
                <i class="fa fa-print"></i> Boleto
            </button>
            <button v-if="analise.forma_pagamento === 'BOLETO' && analise.faturado == '0' && analise.pedido_id != null && gerente"
                    class="btn btn-warning btn-block"
                    @click="buscaParcela(analise); closeModal()"
                    title="Receber parcela">
                <i class="fa fa-check"></i> Receber parcela
            </button>
            <button class="btn btn-success btn-block"
                    v-if="gerente"
                    @click="alterar(analise); closeModal()"
                    title="Alterar">
                <i class="fa fa-pen"></i> Editar
            </button>
            <button class="btn btn-success btn-block" v-if="gerente"
                    @click="digitarResultado(analise); closeModal()"
                    title="Resultado">
                <i class="fa fa-check"></i> Digitar resultado
            </button>
            <button class="btn btn-block btn-info" v-if="analise.tipo == 'SOLO' && analise.solo_quimica == '1' && analise.data_resultado != null && analise.data_resultado.length > 0"
                @click="baixaPDFAdubacao(analise.id)" title="Baixar adubação"> <i class="fa fa-download"></i> Baixar adubação
            </button>
            <button class="btn btn-danger btn-block"
                    v-if="gerente"
                    @click="remover(analise); closeModal()"
                    title="Excluir">
                <i class="fa fa-times"></i> Excluir
            </button>
        </div>
    </vc-modal>
</template>